export default __webpack_public_path__ + "static/media/order.2d47f718.png";